export enum DefaultValidationError {
  Min = 'min',
  Max = 'max',
  Required = 'required',
  Email = 'email',
  MaxLength = 'maxlength',
  Range = 'range',
  MinLength = 'minlength',
  Pattern = 'pattern',
  Forbidden = 'forbidden',
  Number = 'number',
  Cron = 'cron',
  Ip2 = 'ip2',
}
